import React from 'react';
import { MuiTelInput, type MuiTelInputProps } from 'mui-tel-input';
import { flagUrl } from '@src/shared/lib';
import { ArrowDownIcon } from '@src/shared/ui/icons';

// The same flag box in the input and in the country menu.
const flagImg = {
  height: 18,
  objectFit: 'contain',
  objectPosition: 'left center',
  width: 24,
} as const;

const StyleSheet = {
  root: {
    '.MuiInputAdornment-root': {
      mr: 0,
    },
    '.MuiButtonBase-root': {
      aspectRatio: 'auto',
      ml: '6px',
      p: 0,
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    '.MuiTelInput-FlagImg': {
      ...flagImg,
      mr: 0.5,
    },
  },
  // The menu is rendered in a portal, out of reach of the root styles.
  menu: {
    '.MuiTelInput-FlagImg': flagImg,
  },
};

// Local flags instead of the CDN of mui-tel-input; the flags it embeds
// itself (Ascension, Tristan da Cunha) are kept.
const defaultGetFlagElement: MuiTelInputProps['getFlagElement'] = (
  isoCode,
  { imgProps, isSelected },
) => (
  <>
    <img
      {...imgProps}
      src={imgProps.src?.startsWith('data:') ? imgProps.src : flagUrl(isoCode)}
      alt={imgProps.alt ?? ''}
    />
    {isSelected && <ArrowDownIcon fontSize="small" sx={{ color: (theme) => `${theme.palette.grey[800]} !important` }} />}
  </>
);

const PhoneInput = React.forwardRef<HTMLDivElement, MuiTelInputProps>(
  (props, ref) => (
    <MuiTelInput
      ref={ref}
      getFlagElement={defaultGetFlagElement}
      {...props}
      MenuProps={{ sx: StyleSheet.menu }}
      sx={StyleSheet.root}
    />
  ),
);

PhoneInput.displayName = 'PhoneInput';
export default PhoneInput;
